import { Box, Center } from "@chakra-ui/react";
import { Spinner } from "@components/ui-kit";
import {
  useCreditAccountsTableSummaryLazyQuery,
  useGetCreditAccountsLazyQuery,
} from "@src/__generated__/graphql";
import { BrandCreditAccountsSummaryModel } from "@src/components/modules/credit-account/listing/models";
import { onError } from "@src/utils/apollo";
import { useUpdateURI } from "@src/utils/hooks/useUpdateURI";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { CardListCreditAccounts } from "./CardListCreditAccounts";
import { StoreCreditAccounts } from "./StoreCreditAccounts";

export const PageCreditAccountsCtx = React.createContext<StoreCreditAccounts>(
  null as any as StoreCreditAccounts,
);

function useData(store: StoreCreditAccounts) {
  const [
    fetchCreditAccountsSummary,
    { loading: loadingSummary, refetch: refetchSummary },
  ] = useCreditAccountsTableSummaryLazyQuery({
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      if (!data) return;
      store.brandCreditAccountsSummary = new BrandCreditAccountsSummaryModel(
        data.brandCreditAccountsSummary,
      );
    },
    ...onError(),
  });

  const [fetchCreditAccounts, { loading, refetch }] =
    useGetCreditAccountsLazyQuery({
      notifyOnNetworkStatusChange: true,
      onCompleted(data) {
        if (!data) return;
        store.fromGetCreditAccountsQuery(data);
      },
      ...onError(),
    });

  useEffect(() => {
    fetchCreditAccounts({ variables: store.queryParams });
    fetchCreditAccountsSummary({ variables: store.queryParams });
  }, [store.queryParams]);

  store.refetch = () => {
    refetch();
    refetchSummary();
  };

  return { loading, loadingSummary };
}

export const PageCreditAccounts = observer(function PageCreditAccounts() {
  const { query } = useRouter();

  const [store] = useState(() => {
    const store = StoreCreditAccounts.create();
    store.where.fromURLSearchParam(query);
    store.orderBy.fromURLSearchParam(query);
    store.pagination.fromURLSearchParam(query);
    return store;
  });

  useUpdateURI(store.searchParams);

  const { loading, loadingSummary } = useData(store);

  return (
    <PageCreditAccountsCtx.Provider value={store}>
      <Center>
        <Box w="full">
          {loading && <Spinner absolute />}
          <CardListCreditAccounts isSummaryLoaded={!loadingSummary} />
        </Box>
      </Center>
    </PageCreditAccountsCtx.Provider>
  );
});
